export { default as TabHeaderFamilly } from './Familly.tab';
export { default as TabHeaderCareer } from './Career.tab';
export { default as TabHeaderAcademicBackground } from './AcademicBackground.tab';
export { default as TabHeaderEducation } from './Education.tab';
export { default as TabHeaderCertificate } from './Certificate.tab';
export { default as TabHeaderAward } from './Award.tab';
export { default as TabHeaderCar } from './Car.tab';
